import axios from 'axios';

import { healioSpaceAPIURL } from './baseHealioSpaceAPI';
import { installSessionInterceptors } from './sessionInterceptors';

export const authApi = axios.create({
  baseURL: `${healioSpaceAPIURL}`,
  withCredentials: true,
});

installSessionInterceptors(authApi);

/**
 * Interface for the WhoAmI API response
 */
export interface WhoAmIResponse {
  requestingUserID: string | null;
  sub: string;
  'custom:role': string;
  state: string | null;
  username: string;
  email_verified: boolean;
  'cognito:username': string;
  given_name: string;
  origin_jti: string;
  event_id: string;
  token_use: string;
  auth_time: number;
  family_name: string;
  email: string;
  birthdate?: string;
  phone_number_verified: boolean;
  'custom:practice_name'?: string;
  phone_number?: string;
  aud: string;
  exp: number;
  iat: number;
  jti: string;
  issuer: string | null;
  subject: string | null;
  audience: string | null;
  expires: number;
  notBefore: number;
  issuedAt: number;
  jwtId: string | null;
  expiresAtDateTime: string;
  issuedAtDateTime: string;
  notBeforeDateTime: string;
}

/**
 * Validates the current user's token and returns user information
 * @returns Promise<WhoAmIResponse> User information from the token
 * @throws Error if token is invalid or request fails
 */
export const validateToken = async (): Promise<WhoAmIResponse> => {
  try {
    const response = await authApi.get('/Admin/WhoAmI');

    return response.data as WhoAmIResponse;
  } catch (error) {
    console.error('Token validation failed:', error);
    throw error;
  }
};

/**
 * Checks if the current token is valid without throwing errors
 * @returns Promise<boolean> True if token is valid, false otherwise
 */
export const isTokenValid = async (): Promise<boolean> => {
  try {
    await validateToken();

    return true;
  } catch {
    // validateToken already logs the failure

    return false;
  }
};
